import { useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import type { SvpAsset } from '@vgtv/api-client/lib/svp_asset';

import { selectParentalControlsVisible } from '../../../modules/ui';
import { parentalControlsHelper } from '../../../helpers/parentalControls';
import { setParentalControlsManagerVisibility } from '../../../modules/ui/actions';

function useParentalControls(asset?: SvpAsset) {
  const dispatch = useDispatch();

  const showParentalControlsManager = useCallback(
    () => dispatch(setParentalControlsManagerVisibility(true)),
    [dispatch]
  );
  const hideParentalControlsManager = useCallback(
    () => dispatch(setParentalControlsManagerVisibility(false)),
    [dispatch]
  );

  const parentalControlsManagerVisible = useSelector(
    selectParentalControlsVisible
  );

  const canDisplayVideo = useMemo(() => {
    const isLockActive = parentalControlsHelper.isParentalLockSet();

    if (!isLockActive) {
      return true;
    }

    if (!asset) {
      return false;
    }

    const ageLimit = asset.additional?.settings?.ageLimit ?? null;

    return !parentalControlsHelper.isLocked(ageLimit);
  }, [asset]);

  return {
    showParentalControlsManager,
    hideParentalControlsManager,
    parentalControlsManagerVisible,
    canDisplayVideo,
  };
}

export { useParentalControls };
